<template>
    <div class="modal-content">
        <div v-if="type" class="modal-header">
            <h5 class="modal-title" id="user-activity-modal-label">
                {{ $root.text('User ' + type, null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div v-if="type" class="modal-body">
            <p v-if="user">
                {{ $root.text('Total ' + type + ' by {name}', { name: user.first_name + ' ' + user.last_name }, true) }}
                - {{ total_items }}
            </p>

            <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

            <div v-if="!errors" class="activity-items">
                <div class="table-responsive">
                    <table v-if="type == 'visits'" class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-6">{{ $root.text('Visited on', null, true) }}</div>
                                        <div class="col-6">{{ $root.text('Device', null, true) }}</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row">
                                    <user-activity-item :type="type" :data="item"></user-activity-item>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-if="type == 'uploads'" class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-sm-4 col-6"></div>
                                        <div class="col-lg-7 col-md-6 col-sm-8 col-6">
                                            {{ $root.text($root.contents.asset_title, null, true, 'asset_title') }}
                                        </div>
                                        <div class="col-md-3 col-12 d-none d-md-block">
                                            {{ $root.text('Uploaded on', null, true) }}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td scope="row">
                                    <user-activity-item :type="type" :data="item"></user-activity-item>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-if="type == 'downloads'" class="table table-centered table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    <div class="row">
                                        <div class="col-lg-2 col-md-3 col-sm-4 col-6"></div>
                                        <div class="col-lg-7 col-md-6 col-sm-8 col-6">
                                            {{ $root.text($root.contents.asset_title, null, true, 'asset_title') }}
                                        </div>
                                        <div class="col-md-3 col-12 d-none d-md-block">
                                            {{ $root.text('Downloaded on', null, true) }}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id + '-' + item.download_id">
                                <td scope="row">
                                    <user-activity-item :type="type" :data="item"></user-activity-item>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div v-if="loading" style="position: absolute; left: 0; bottom: 7px; width: 100%">
                <loading></loading>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                user: null,
                type: null,
                loading: false,
                errors: false,
                items: [],
                total_items: 0,
                current_page: 1,
                last_page: 1,
                get_date_time_formatted_response: null
            }
        },
        mounted () {
            var vm = this;
            $('.activity-items').on('scroll', function () {
                vm.handleScroll();
            });
        },
        watch: {
            get_date_time_formatted_response: function (val) {
                if (val) {
                    if (val.status == 200) {
                        if (this.type == 'visits') {
                            $('#date' + val.id.substr(3)).html(val.date_time_formatted);
                        } else {
                            $('#datemd' + val.id.substr(3)).html(val.date_time_formatted);
                            $('#datexs' + val.id.substr(3)).html(val.date_time_formatted);
                        }
                    }
                }
            }
        },
        methods: {
            reset: function (user, type, total) {
                this.user = user;
                this.type = type;
                this.total_items = total;
                this.getReport();
            },
            getReport: function (page = 1) {
                if (this.loading || (page < 1) || ((page > 1) && (page <= this.current_page))) {
                    return false;
                }
                this.current_page = page;
                this.loading = true;
                this.errors = false;
                if (page == 1) {
                    this.items = [];
                    this.current_page = 1;
                    this.last_page = 1;
                }
                let report = 'visits/ur::' + this.user.id;
                switch (this.type) {
                    case 'uploads':
                        report = 'resource-uploads/cb::' + this.user.id;
                        break;
                    case 'downloads':
                        report = 'resource-downloads/ur::' + this.user.id;
                        break;
                }

                /**
                 * Send request to API
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/report/' + report + '?page='
                    + page;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.total_items = response.data[vm.type].total;
                    vm.current_page = response.data[vm.type].current_page;
                    vm.last_page = response.data[vm.type].last_page;
                    response.data[vm.type].data.forEach((item) => {
                        vm.items.push(item);
                        if (vm.type == 'downloads') {
                            vm.$root.getDateTimeFormatted(
                                vm,
                                'df_' + item.id + '-' + item.download_id,
                                item.downloaded_at
                            );
                        } else {
                            vm.$root.getDateTimeFormatted(vm, 'df_' + item.id, item.created_at);
                        }
                    });
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        vm.$root.doLogout();
                    }
                    vm.errors = error.response.data.error
                        || vm.$root.text('Something went wrong, please try again', null, true);
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            handleScroll() {
                if (this.items.length == 0) {
                    return null;
                }
                if ((this.current_page < this.last_page) && !this.loading) {
                    const scrollTop = $('.activity-items').scrollTop();
                    const contentHeight = $('.activity-items .table-responsive').outerHeight();
                    const scrollPosition = contentHeight - (scrollTop + 450);
                    if (scrollPosition < 200) {
                        this.getReport(this.current_page + 1);
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .activity-items {
        height: 450px;
        overflow-y: auto;
    }
</style>
